export const isExternalLink = (to: string) =>
  ['http', 'https', 'mailto', 'tel'].some((str) => to.includes(str));
